import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const DashboardPage = () => (
  <>
    <DataTable tableStyle={{ minWidth: '50rem' }}>
      <Column field='code' header='Code'></Column>
      <Column field='name' header='Name'></Column>
      <Column field='category' header='Category'></Column>
      <Column field='quantity' header='Quantity'></Column>
    </DataTable>
  </>
);

const DashboardWrapper = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  );
};

export { DashboardWrapper };
